// extracted by mini-css-extract-plugin
export var table = "_u4-0";